// extracted by mini-css-extract-plugin
export default {"total-price-wrapper":"OrBpri","bundle-discount":"wrUfq6","bundle-price":"eIWTxQ"};